<div class="row subheading-18p tile-color mt-1" [innerHTML]="'globalrichtext.SwitchToWebUpdateContent' | translate | safeHtml">
</div>